<template>
  <div class="table_block">
    <!-- <Row ref="dataTable"> -->
      <Table
        :loading="loading"
        border
        width='100%'
        stripe :columns="columns"
        :data="table.data"
        size="small"
        :height="height"
        disabled-hover
        highlight-row
        @on-selection-change="selectionChange"
        @on-row-click="onRowClick"
      ></Table>
      <div class="mt-2 page_out">
        <Page
          :total="pagination.total"
          :page-size-opts="pagination.sizes"
          :current="pagination.search.PageIndex_show"
          :page-size="pagination.search.PageSize"
          show-elevator
          show-sizer
          show-total
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
        />
         <!-- <Page :total="100"></Page> -->
      </div>

      <RouterModel ref="routerModal"></RouterModel>
    <!-- </Row> -->
  </div>
</template>

<script>
import helper from "@/utils/helper.js";
import RouterModel from "@/components/RouterModal.vue";

export default {
  name: "NormalTable",
  components: { RouterModel },
  props: {
    columns: {
      type: Array,
      default() {
        return [];
      },
    },
    apiUrl: {
      type: [Number, String],
    },
    search: {
      type: Object,
    },
    height:{
      type: [Number, String],
      default: 'auto'
    }
  },
  data: function () {
    return {
      loading: false,
      table: {
        data: [],
        height: 0,
      },
      pagination: {
        total: 0,
        sizes: [10, 20, 30, 50],
        search: {
          PageIndex: 1,
          // PageIndex_show: 1,
          PageSize: 10,
        },
      },
    };
  },
  // created: function () {
  //   this.load();
  //   // this.load_yinyang();
  // },
  methods: {
    //报告修订统计/危急值修订统计---- 的分页表格(目前就这两个父组件再用)
    load: function () {
      //合并搜索条件
      this.loading = true;
      var temp = Object.assign({}, this.search, this.pagination.search); //合并对象
      console.log('url',this.apiUrl);
      this.$api.get(this.apiUrl, temp).then((rsp) => {
        if (rsp != false) {
          this.table.data = rsp.data.item1;
          console.log('分页请求的表格数据111',this.table.data);
          this.pagination.total = rsp.data.item2;
          this.loading = false;
        }
      });
    },
    //报告修订统计/危急值修订统计---- 的分页表格(目前就这两个父组件再用)
    // load_yinyang: function () {
    //   //合并搜索条件
    //   this.loading = true;
    //   var temp = Object.assign({}, this.search, this.pagination.search); //合并对象
    //   console.log('url',this.apiUrl);
    //   this.$api.get(this.apiUrl, temp).then((rsp) => {
    //     if (rsp != false) {
    //       this.table.data = rsp.data.item1;
    //       console.log('分页请求的表格数据111',this.table.data);
    //       this.pagination.total = rsp.data.item2;
    //       this.loading = false;
    //     }
    //   });
    // },

    initload: function () {
      //合并搜索条件
      this.loading = true;
      this.pagination.search.PageIndex = 1;
      var temp = Object.assign({}, this.search, this.pagination.search);
      this.$api.get(this.apiUrl, temp).then((rsp) => {
        // this.table.data = rsp.data.list;
        // this.pagination.total = rsp.data.total;
        this.table.data = rsp.data.item1;
        this.pagination.total = rsp.data.item2;
        this.loading = false;
      });
    },

    //分页
    pageChange: function (page) {
       this.pagination.search.PageIndex = page;
      this.load();
    },
    sizeChange: function (size) {
      this.pagination.search.PageSize = size;
      if(this.pagination.search.PageIndex==1){
        this.load();
      }else{
        this.pagination.search.PageIndex = 1;
      }
    },
    //模态框
    openModel: function (title, path) {
      this.$refs.routerModal.openModel(title, path);
    },
    closeModel: function () {
      this.$refs.routerModal.closeModel();
    },

    //多选框触发事件
    selectionChange: function (data) {
      this.$emit("selectionChange", data);
    },
    onRowClick: function (data) {
      this.$emit("onRowClick", data);
    },
  },
};
</script>
<style scoped>
  .table_block{
    background: #fff;
    border-radius: 10px;
    padding: 15px;
  }
  .page_out{
    width: 100%;
    text-align: right;
  }
</style>
